// extracted by mini-css-extract-plugin
export default {"maxWidth":"HeaderWithoutUser_maxWidth__r1IND"};